import styles from './ccf-chat-box.module.scss';
import {
  activeContactSelector,
  getActiveInteractionID,
  getInteractionTabs,
  updatePropertyOfAgentReply,
  selectLoginCredentialsState,
} from '@nice-ccf/ui-components';
import {
  CcfBox,
  CcfDividerWithText,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { Fragment, useState } from 'react';
import {
  getChatType,
  selectedConsultantForChat,
  getChatLoadingState,
} from './+state/ccf-chat-box.state';
import { Chip, CircularProgress, Link } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { CcfCustomerCardAddNotes } from '../../ccf-inbox/ccf-customer-card/ccf-customer-notes/ccf-customer-card-add-notes';
import CcfCoBrowseSession from '../../ccf-inbox/ccf-co-browse-session/ccf-co-browse-session';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
/* eslint-disable-next-line */
export interface CcfChatBoxProps {
  i?: any;
  isMiniCard?: boolean;
  replyCard?: any;
  showHighligtedCard?: boolean;
}

/**
 * Component displays chat box tab in interaction workspace
 * @param props -CcfChatBoxProps
 * @returns chatbox component
 * @example <CcfChatBox/>
 */
export function CcfChatBox(props: CcfChatBoxProps) {
  const selectedCallContact = useSelector(activeContactSelector);
  const chatType = useSelector(getChatType);
  const userInChatConsult = useSelector(selectedConsultantForChat);
  const isLoading = useSelector(getChatLoadingState);
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const loginCredentials = useSelector(selectLoginCredentialsState);
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const agentFullName = isAuthenticated
    ? loginCredentialsArray[0].charAt(0).toUpperCase() +
      loginCredentialsArray[0].slice(1).toLowerCase() +
      ' ' +
      loginCredentialsArray[1].charAt(0).toUpperCase() +
      loginCredentialsArray[1].slice(1).toLowerCase()
    : loginCredentials.firstName.charAt(0).toUpperCase() +
      loginCredentials.firstName.slice(1).toLowerCase() +
      ' ' +
      loginCredentials.lastName.charAt(0).toUpperCase() +
      loginCredentials.lastName.slice(1).toLowerCase();
  const interactionTabs = useSelector(getInteractionTabs) || {};
  const activeInteractionID: string = useSelector(getActiveInteractionID) || '';
  const dispatch = useDispatch();

  /**
   * Handle cancel note to cancel note
   * @param e -
   * @example -
   */
  const handleCancelNote = (labelText: string, e?: any) => {
    if (props?.replyCard?.messageContent.payload.text.length) {
      dispatch(
        updatePropertyOfAgentReply({
          interactionId: activeInteractionID,
          deleteTweetId: props?.replyCard?.messageId,
          actionType: labelText,
        })
      );
    } else {
      dispatch(
        updatePropertyOfAgentReply({
          interactionId: activeInteractionID,
          deleteTweetId: props?.replyCard?.messageId,
          actionType: labelText,
        })
      );
    }
  };
  return (
    <div
      className={
        (props?.replyCard?.messageContent !== undefined &&
          props?.replyCard?.messageContent?.payload?.text !== '') ||
        (props?.replyCard?.messageContent?.payload?.text === '' &&
          (props?.replyCard?.messageContent.payload?.linkContent?.length > 0 ||
            props?.replyCard?.messageContent.payload?.imageContent?.length >
              0 ||
            props?.replyCard?.messageContent.payload?.processContent?.length >
              0))
          ? styles.container
          : styles.noshow
      }
    >
      {props?.replyCard?.conferenceMsg && chatType === 'conference' ? (
        <div className={styles['clear']}>
          {(isLoading && (
            <CcfBox textAlign="center" mt={3} width="100%">
              <CircularProgress size={20} />
            </CcfBox>
          )) || (
            <Fragment>
              <CcfDividerWithText>
                <Chip
                  size="small"
                  color="primary"
                  label={`Agent ${userInChatConsult?.name} has joined the conversation`}
                />
              </CcfDividerWithText>
              <div className={styles.emailCardMainContainer}>
                <CcfTypography
                  variant="caption"
                  style={{ fontWeight: 600 }}
                  className={
                    props?.replyCard?.authorUser.emailAddress ===
                    'customer.service@delta.com'
                      ? styles.agentName
                      : styles.clientName
                  }
                >
                  {userInChatConsult?.name}
                </CcfTypography>
                <CcfBox
                  className={
                    props?.replyCard?.authorUser.emailAddress ===
                    'customer.service@delta.com'
                      ? styles.agentMessageBox
                      : styles.clientMessageBox
                  }
                >
                  <CcfTypography variant="inherit">
                    {props?.replyCard?.messageContent.payload.text}
                  </CcfTypography>
                  <Link
                    color="inherit"
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontSize: 12,
                    }}
                  >
                    Status Link
                  </Link>
                </CcfBox>
                <CcfTypography variant="caption" style={{ marginLeft: '97%' }}>
                  now
                </CcfTypography>
              </div>
            </Fragment>
          )}
        </div>
      ) : (
        (props?.replyCard?.messageContent?.payload?.text !== '' ||
          (props?.replyCard?.messageContent?.payload?.text === '' &&
            (props?.replyCard?.messageContent?.payload?.linkContent?.length >
              0 ||
              props?.replyCard?.messageContent?.payload?.imageContent?.length >
                0 ||
              props?.replyCard?.messageContent?.payload?.processContent
                ?.length > 0))) && (
          <CcfBox
            className={
              props?.replyCard?.authorUser?.emailAddress ===
                'customer.service@delta.com' ||
              props?.replyCard?.authorUser?.emailAddress === 'bot@nice.com' ||
              props.replyCard?.authorUser?.emailAddress === 'autopilot@nice.com'
                ? styles.msgCardContainer
                : ''
            }
          >
            {props?.replyCard?.messageContent?.type === 'DIVIDER' ? (
              <CcfDividerWithText>
                <Chip size="small" color="primary" label={`Transcript Ended`} />
              </CcfDividerWithText>
            ) : props?.replyCard?.messageContent?.type === 'NOTES' ? (
              <CcfCustomerCardAddNotes
                noteId={props?.replyCard?.messageId}
                isFromWebChat={true}
                isEditModeOn={props?.replyCard?.isEditNote}
                handleCancelNote={handleCancelNote}
                notesContentFromWebChat={
                  props?.replyCard?.messageContent.type === 'NOTES' &&
                  props?.replyCard?.messageContent.payload.text !== ''
                    ? props?.replyCard?.messageContent.payload.text
                    : ''
                }
              />
            ) : props?.replyCard?.messageContent?.type === 'COBROWSE' ? (
              <>
                {' '}
                <CcfCoBrowseSession />
                <CcfTypography
                  variant="caption"
                  style={{ marginRight: '10px' }}
                >
                  {props?.replyCard?.createdAt}
                </CcfTypography>
              </>
            ) : (
              <>
                <CcfTypography
                  style={{ fontWeight: 600 }}
                  className={
                    props?.replyCard?.authorUser?.emailAddress ===
                      'customer.service@delta.com' ||
                    props?.replyCard?.authorUser?.emailAddress ===
                      'bot@nice.com' ||
                      props.replyCard?.authorUser?.emailAddress === 'autopilot@nice.com'
                      ? styles.agentName
                      : styles.clientName
                  }
                >
                  {props?.replyCard?.authorUser?.emailAddress ===
                  'customer.service@delta.com'
                    ? agentFullName
                    : props?.replyCard?.authorUser?.emailAddress ===
                      'bot@nice.com'
                    ? 'Copilot Bot'
                    : props?.replyCard?.authorUser?.emailAddress ===
                      'autopilot@nice.com'
                    ? 'AutoPilot Bot'
                    : `${[
                        selectedCallContact?.customer?.firstName,
                        selectedCallContact?.customer?.middleName,
                        selectedCallContact?.customer?.lastName,
                      ]
                        .filter(Boolean)
                        .join(' ')}`}
                </CcfTypography>{' '}
                <CcfBox
                  className={
                    props?.replyCard?.authorUser?.emailAddress ===
                    'customer.service@delta.com'
                      ? styles.agentMessageBox
                      : (props?.replyCard?.authorUser?.emailAddress ===
                        'bot@nice.com' ||
                        props.replyCard?.authorUser?.emailAddress === 'autopilot@nice.com')
                      ? styles.botMessageBox
                      : props.showHighligtedCard
                      ? styles.clientMessageBoxHighlighted
                      : styles.clientMessageBox
                  }
                >
                  {props?.replyCard?.messageContent?.payload?.text?.length >
                    0 && props?.replyCard?.messageContent?.payload?.text}
                  {props?.replyCard?.messageContent?.payload?.linkContent
                    ?.length > 0 && (
                    <CcfBox>
                      {props?.replyCard?.messageContent?.payload?.linkContent.map(
                        (link: any) => {
                          return (
                            <CcfTypography className={styles.txt}>
                              Link:{' '}
                              <a href={link} rel="noreferrer" target="_blank">
                                {link}
                              </a>
                            </CcfTypography>
                          );
                        }
                      )}
                    </CcfBox>
                  )}
                  {props?.replyCard?.messageContent?.payload?.imageContent
                    ?.length > 0 && (
                    <CcfBox className={styles.imageBlock}>
                      {props?.replyCard?.messageContent?.payload?.imageContent.map(
                        (image: any) => {
                          return (
                            <img
                              className={styles.imageBox}
                              alt={image}
                              src={image.imgSrc}
                            />
                          );
                        }
                      )}
                    </CcfBox>
                  )}
                  {props?.replyCard?.messageContent?.payload?.processContent
                    ?.length > 0 && (
                    <CcfBox>
                      {props?.replyCard?.messageContent?.payload?.processContent.map(
                        (process: any, index: number) => {
                          return (
                            <CcfTypography
                              className={styles.txt}
                              style={{ color: '#ffffff' }}
                            >
                              {`${index + 1}. ${process?.description}`}
                            </CcfTypography>
                          );
                        }
                      )}
                    </CcfBox>
                  )}
                </CcfBox>{' '}
                <CcfTypography variant="caption">
                  {props?.replyCard?.createdAt}
                </CcfTypography>
              </>
            )}
          </CcfBox>
        )
      )}
    </div>
  );
}
export default CcfChatBox;
